import { IShapefile } from "models/projects";

import { ColorPicker } from "components/base";
import {
  FlexItem,
  LeafTitle
} from "components/project/layers/components/layer-managers/shared";
import { useRightClickContextMenu } from "components/project/layers/components/layer-managers/shared/hooks/useRightClickContextMenu";
import { ShapefileActions } from "components/project/layers/components/layer-managers/shared/shapefile-actions/ShapefileActions";
import { useDeleteProjectShapefileMutation } from "components/project/shapefiles/mutations";

export default function SystemShapefileNode({ node, hasActions = true }) {
  const { openContextMenu, contextMenuObject } = useRightClickContextMenu();
  const deleteShapefile = useDeleteProjectShapefileMutation({
    projectId: "system"
  });

  const sf = node as IShapefile;

  return (
    <LeafTitle onContextMenu={openContextMenu}>
      <FlexItem>
        <ColorPicker
          isAtShapefileLevel={true}
          isReadOnly={true}
          values={{
            color: sf.color,
            strokeColor: sf.strokeColor,
            thickness: sf.thickness,
            opacity: (sf.opacity ?? 1) * 100
          }}
        />

        <label>{node.title}</label>
      </FlexItem>
      {hasActions && (
        <FlexItem>
          <ShapefileActions
            hasSelectItems={false} // Only available in project tree
            contextMenu={contextMenuObject}
            fileName={node.title}
            deleteShapefile={() => {
              deleteShapefile.mutate({
                shapefileId: sf.shapefileId,
                projectId: "system"
              });
            }}
          />
        </FlexItem>
      )}
    </LeafTitle>
  );
}
